import type { Card } from './card.js';

export type PileType = 'tableau' | 'foundation' | 'stock' | 'waste' | 'cell' | 'peak';

export interface Pile {
  readonly id: string;
  readonly type: PileType;
  cards: Card[];
}

export interface GameState {
  piles: Record<string, Pile>;
  movesCount: number;
}

export function topCard(pile: Pile): Card | undefined {
  return pile.cards[pile.cards.length - 1];
}

export function findPileWithCard(state: GameState, cardId: string): Pile | undefined {
  for (const pile of Object.values(state.piles)) {
    if (pile.cards.some((c) => c.id === cardId)) return pile;
  }
  return undefined;
}

export function cloneState(state: GameState): GameState {
  const piles: Record<string, Pile> = {};
  for (const [id, pile] of Object.entries(state.piles)) {
    piles[id] = {
      id: pile.id,
      type: pile.type,
      cards: pile.cards.map((c) => ({ ...c })),
    };
  }
  return { piles, movesCount: state.movesCount };
}
